export default __webpack_public_path__ + "media/images/home/slide_near_sea_2026_lg-ed9f1c525cf60811f301ab99ac614f48.jpg";